import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useModal } from '../../hooks/useModal/useModal';
import { ModalWrapper } from './styles';

export const ModalsScrollWrapper = ({ children }: any) => {
  const { isShowingAny, close } = useModal();
  const scrollY = useRef<number>(0);
  const lockPathname = useRef<string | null>(null);
  const location = useLocation();

  const lockScroll = () => {
    scrollY.current = window.scrollY;

    lockPathname.current = location.pathname;

    document.body.classList.add('no-scroll');
  };

  const unlockScroll = () => {
    document.body.classList.remove('no-scroll');

    if (lockPathname.current === location.pathname) {
      // Restore scroll position for older browsers to prevent jumping of page to top
      window.scrollTo(0, scrollY.current);
    }

    lockPathname.current = null;
  };

  const handleModalStateChange = () => {
    if (isShowingAny) {
      lockScroll();
    } else {
      unlockScroll();
    }
  };

  const handleRouteChange = () => {
    close();
    unlockScroll();
  };

  const handleWindowEvents = () => {
    if (isShowingAny) {
      lockScroll();
    }
  };

  // Handle opening/closing of modal
  useEffect(() => {
    handleModalStateChange();

    return () => unlockScroll();
  }, [isShowingAny]);

  // Handle route changes for cases where modal was opened and navigated away
  useEffect(() => {
    handleRouteChange();
  }, [location.pathname]);

  // Windows events to handle reapplying scroll lock
  // ex. when user opens mailto: link on modal, the page loses focus due to email client being launched
  useEffect(() => {
    window.addEventListener('focus', handleWindowEvents);
    window.addEventListener('visibilitychange', handleWindowEvents);

    return () => {
      window.removeEventListener('focus', handleWindowEvents);
      window.removeEventListener('visibilitychange', handleWindowEvents);
    };
  }, [isShowingAny]);

  return (
    <ModalWrapper data-testid="modal-wrapper" id="main-layout-root">
      {children}
    </ModalWrapper>
  );
};
